export function getFullAddressForProperty(property) {
  const street = [
    property.street && property.street,
    property.number && property.number,
    property.box && `bus ${property.box}`,
  ]
  const city = [property.zip && property.zip, property.city && property.city]
  const address = [street.filter(Boolean).join(' '), city.filter(Boolean).join(' ')]

  return address.filter(Boolean).join(', ')
}

export function getBrokerForProperty(property) {
  return property.broker
}



// WEBPACK FOOTER //
// ./src/utils/property.js